import { getAnalyticsRoi } from 'store/analytics/actions'
import type { GetAnalyticsRoiDataResponse, GetAnalyticsRoiPayload } from 'store/analytics/types'
import { useSelector } from 'store/hooks'

import type { UseQuerySelectOptions, UseQuerySelectResult } from 'hooks'

import { useQuerySelect } from 'hooks'

import { useAnalyticsAreaParam, withAnalyticsArea } from './useAnalyticsAreaParam'


type UseAnalyticsParams = GetAnalyticsRoiPayload

type UseAnalyticsResult = {
  data: GetAnalyticsRoiDataResponse | null
} & UseQuerySelectResult<UseAnalyticsParams>

export const useAnalyticsRoi = (params: UseAnalyticsParams, options?: UseQuerySelectOptions): UseAnalyticsResult => {
  /*
    The page-global drawn area (VRG-480), merged in HERE rather than at the call site.
    See `useAnalyticsAreaParam` — the merge is inside the hook so a new analytics card
    cannot forget it, and so `useQuerySelect`'s params comparison sees the ring and
    refetches when it changes.
  */
  const areaParam = useAnalyticsAreaParam()
  const request = withAnalyticsArea(params, areaParam)

  const result = useQuerySelect(getAnalyticsRoi, request, options)
  const data = useSelector(state => state.analytics.roi)

  return {
    data,
    ...result,
  }
}
